import { gatewayApi as api } from './gatewayApi';

// Types
export interface DocumentDownload {
  DocFile: string; // Base64 data URL or file URL
  Name: string;
  DocumentType: string;
  Id: string;
}

// Document API Service
export const documentApi = {
  // Download document by ID (base64/URL metadata)
  download: (documentId: string): Promise<DocumentDownload> =>
    api.get<DocumentDownload>(`/document/download/${documentId}`),

  // Get document by ID (alternative endpoint)
  getById: (documentId: string): Promise<DocumentDownload> =>
    api.get<DocumentDownload>(`/document/${documentId}`),
}; 